// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.imgageproperty[data-v-b48596e8] {\r\n  margin-right: 14px;\r\n  height: 24px;\n}\n.tab-divider[data-v-b48596e8] {\r\n  border-right: 3px solid #ccd2d7;\n}\n.tab-divider[data-v-b48596e8]:last-child  {\r\n  border-right: 0\n}\r\n", ""]);
// Exports
module.exports = exports;
